import React, { useRef, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import useOutsideClick from 'shared/lib/useOutsideClick';
import useOutsideScroll from 'shared/lib/useOutsideScroll';

const useTooltip = (tooltipContent, checkName = 'noShowTooltip') => {
  const triggerRef = useRef();
  const tooltipRef = useRef(null);
  const tooltipOutsideClickRef = useOutsideClick(() => setVisible(false));
  const tooltipOutsideScrollRef = useOutsideScroll(() => setVisible(false));

  const handleRef = (node) => {
    tooltipRef.current = node;
    tooltipOutsideClickRef.current = node;
    tooltipOutsideScrollRef.current = node;
  };

  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    if (localStorage.getItem(checkName) === 'true') return;

    setVisible(true);
  };

  useEffect(() => {
    const triggerElement = triggerRef.current;
    if (triggerElement) {
      triggerElement.addEventListener('dblclick', toggleVisibility);
      return () => {
        triggerElement.removeEventListener('dblclick', toggleVisibility);
      };
    }
  }, [triggerRef]);

  useEffect(() => {
    if (visible && tooltipRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const top = triggerRect.top + triggerRect.height / 2 - tooltipRect.height / 2;
      const marginLeft = 5;
      const left = triggerRect.right + marginLeft;
      tooltipRef.current.style.top = `${top}px`;
      tooltipRef.current.style.left = `${left}px`;
      tooltipRef.current.style.visibility = 'visible';
    }
  }, [visible]);

  const handleChange = (e) => {
    if (e.target.checked) {
      localStorage.setItem(checkName, 'true');
    } else {
      localStorage.removeItem(checkName);
    }
  };

  const closeTooltipHandler = () => setVisible(false);

  const tooltip = visible
    ? createPortal(
        <div ref={handleRef} className="warning-tooltip">
          <div className="warning-tooltip__container">
            {tooltipContent}
            <div className="warning-tooltip__no-more">
              <div className="checkbox checkbox-primary warning-tooltip__checkbox">
                <input
                  type="checkbox"
                  className="s-modal__checkbox-input warning-tooltip__checkbox-input"
                  id="no-more"
                  onChange={handleChange}
                />
                <label htmlFor="no-more" className="s-modal__checkbox-label warning-tooltip__label">
                  {i18n.t('no_show_more')}
                </label>
              </div>
            </div>
            <button className="warning-tooltip__close-btn" onClick={closeTooltipHandler}>
              <i className="fi fi-close" />
            </button>
          </div>
        </div>,
        document.body
      )
    : null;

  return [triggerRef, tooltip];
};

export default useTooltip;
